import { render, staticRenderFns } from "./RegisterTank.vue?vue&type=template&id=467d76f6&scoped=true&"
import script from "./RegisterTank.vue?vue&type=script&lang=js&"
export * from "./RegisterTank.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTank.vue?vue&type=style&index=0&id=467d76f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d76f6",
  null
  
)

export default component.exports